module.exports = __webpack_public_path__ + "media/images/team_member/member_7-2896dd9658ace0c53ec97339982cca97.jpg";